// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as Belt_Set from "@rescript/runtime/lib/es6/Belt_Set.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as FileSaver from "file-saver";
import * as LumiRequest from "lumi-rescript/lib/es6/src/LumiRequest.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Primitive_int from "@rescript/runtime/lib/es6/Primitive_int.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Belt_SortArray from "@rescript/runtime/lib/es6/Belt_SortArray.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Locale$LumiI18n from "lumi-i18n/lib/es6/src/Locale.res.js";
import * as ReactChartjs from "react-chartjs-2";
import * as LumiReactReducer from "lumi-rescript/lib/es6/src/LumiReactReducer.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Primitive_string from "@rescript/runtime/lib/es6/Primitive_string.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Translation$Dashboard from "./Translation.res.js";
import * as Statistics$LumiCentral from "lumi-central/lib/es6/src/Statistics.res.js";
import * as Stallingsnet$LumiCentral from "lumi-central/lib/es6/src/Stallingsnet.res.js";
import * as StatisticsTypes$Dashboard from "./StatisticsTypes.res.js";
import * as Barrier$LumiAuthentication from "lumi-authentication/lib/es6/src/Barrier.res.js";
import * as SensorGroups$LumiStaticData from "lumi-static-data/lib/es6/src/SensorGroups.res.js";

function getSelectedGroups(selectedGroups, groupsSettings) {
  return Belt_Map.keep(groupsSettings, (param, _settings) => Belt_Set.has(selectedGroups, param.groupFullId));
}

function updateGroup(groupsSettings, group, f) {
  return Belt_Map.update(groupsSettings, group, entry => Stdlib_Option.map(entry, f));
}

let colors = [
  "#e41a1c",
  "#377eb8",
  "#4daf4a",
  "#984ea3",
  "#ff7f00",
  "#a65628",
  "#f781bf",
  "#999999"
];

function getNextColor(state) {
  let groupsWithColors = Belt_Map.size(Belt_Map.keep(state.groupsSettings, (param, param$1) => Stdlib_Option.isSome(param$1.color)));
  let index = Primitive_int.mod_(groupsWithColors, colors.length);
  return colors[index];
}

function Statistics$GroupList(props) {
  let dispatch = props.dispatch;
  let selectedGroups = props.selectedGroups;
  let groupsSettings = props.groupsSettings;
  return JsxRuntime.jsxs("nav", {
    children: [
      JsxRuntime.jsx("p", {
        children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: "Facilities"
        }),
        className: "panel-heading"
      }),
      JsxRuntime.jsx("div", {
        children: Belt_SortArray.stableSortBy(props.facilityInfos, (param, param$1) => {
          let a = Document$LumiStore.contents(param.facility);
          let b = Document$LumiStore.contents(param$1.facility);
          return Primitive_string.compare(a.name, b.name);
        }).map(param => {
          let facilityDoc = param.facility;
          let facility = Document$LumiStore.contents(facilityDoc);
          return [JsxRuntime.jsx("div", {
              children: facility.name,
              className: LumiReact.classList([
                [
                  "panel-block",
                  true
                ],
                [
                  "is-unselectable",
                  true
                ],
                [
                  "has-text-weight-bold",
                  true
                ]
              ])
            }, Document$LumiStore.Key.toString(facilityDoc.key))].concat(Belt_SortArray.stableSortBy(param.groups, (param, param$1) => Primitive_string.compare(param.name, param$1.name)).map(group => {
            let selected = Belt_Set.has(selectedGroups, group.groupFullId);
            let action = selected ? ({
                TAG: "DeselectGroup",
                _0: group
              }) : ({
                TAG: "SelectGroup",
                _0: group
              });
            let color = Stdlib_Option.getOr(Stdlib_Option.flatMap(Belt_Map.get(groupsSettings, group), param => param.color), "black");
            return JsxRuntime.jsxs("a", {
              children: [
                selected ? JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                      name: "check-square"
                    }),
                    className: "panel-icon",
                    style: {
                      color: color
                    }
                  }) : JsxRuntime.jsx("span", {
                    children: JsxRuntime.jsx(FontAwesome$Web.Regular.make, {
                      name: "square"
                    }),
                    className: "panel-icon"
                  }),
                group.name
              ],
              className: LumiReact.classList([
                [
                  "panel-block",
                  true
                ],
                [
                  "is-unselectable",
                  true
                ],
                [
                  "is-active",
                  selected
                ]
              ]),
              onClick: param => dispatch(action)
            }, SensorGroups$LumiStaticData.GroupFullId.toString(group.groupFullId));
          }));
        }),
        className: "facility-list-members scrollable"
      })
    ],
    className: "panel has-scrollable-members"
  });
}

let GroupList = {
  make: Statistics$GroupList
};

function Statistics$Chart(props) {
  let metric = props.metric;
  let interval = props.interval;
  let locale = Locale$LumiI18n.useContext();
  let options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: "time",
        time: {
          tooltipFormat: interval === "week" ? "w (PPP)" : (
              interval === "day" ? "PPPP" : (
                  interval === "month" ? "MMMM yyyy" : "PPPPp"
                )
            )
        },
        adapters: {
          date: {
            locale: Locale$LumiI18n.toDateFnsLocale(locale)
          }
        }
      },
      y: metric === "occupancyPctMean" || metric === "occupancyPctMin" || metric === "occupancyPctMax" ? ({
          type: "linear",
          min: 0,
          max: 100
        }) : ({
          type: "linear"
        })
    },
    interaction: {
      mode: "nearest",
      axis: "x",
      intersect: false
    },
    plugins: {
      tooltip: {
        position: "nearest"
      }
    },
    pointHoverRadius: 10
  };
  let data = {
    datasets: Stdlib_Array.filterMap(Belt_Map.toArray(getSelectedGroups(props.selectedGroups, props.groupsSettings)), param => {
      let match = param[1];
      let color = match.color;
      let namedGroup = param[0];
      return Stdlib_Option.map(match.statistics, statistics => ({
        label: namedGroup.name,
        backgroundColor: color,
        borderColor: color,
        stepped: "before",
        data: statistics.map(param => {
          let agg = param[1];
          let capacity = Math.round(agg.freeMean + agg.occupiedMean + agg.errorMean);
          let occupiedMin = (capacity | 0) - agg.freeMax | 0;
          let occupiedMean = capacity - agg.freeMean;
          let occupiedMax = (capacity | 0) - agg.freeMin | 0;
          return [
            param[0],
            metric === "occupancyPctMin" ? occupiedMin / capacity * 100 : (
                metric === "occupiedMean" ? occupiedMean : (
                    metric === "occupancyPctMean" ? occupiedMean / capacity * 100 : (
                        metric === "occupiedMax" ? occupiedMax : (
                            metric === "freeMean" ? agg.freeMean : (
                                metric === "freeMin" ? agg.freeMin : occupiedMax / capacity * 100
                              )
                          )
                      )
                  )
              )
          ];
        })
      }));
    })
  };
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(ReactChartjs.Line, {
      data: data,
      options: options
    }),
    className: "is-flex-1",
    style: {
      minWidth: "0",
      position: "relative"
    }
  });
}

let Chart = {
  make: Statistics$Chart
};

function Statistics$Controls$Field(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("label", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: props.label
          }),
          className: "label"
        }),
        className: "panel-block"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: props.children,
          className: "control"
        }),
        className: "panel-block"
      })
    ]
  });
}

let Field = {
  make: Statistics$Controls$Field
};

function Statistics$Controls(props) {
  let dispatch = props.dispatch;
  let singleGroup = props.singleGroup;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("p", {
        children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
          entry: "Criteria"
        }),
        className: "panel-heading"
      }),
      JsxRuntime.jsx(Statistics$Controls$Field, {
        label: "StartDate",
        children: JsxRuntime.jsx("input", {
          className: "input",
          type: "date",
          value: Stdlib_Option.getOr(Stdlib_Option.map(props.begin, LumiDate.dateWireFormat), ""),
          onChange: e => dispatch({
            TAG: "SetBegin",
            _0: Primitive_option.fromNullable(e.target.valueAsDate)
          })
        })
      }),
      JsxRuntime.jsx(Statistics$Controls$Field, {
        label: "EndDate",
        children: JsxRuntime.jsx("input", {
          className: "input",
          type: "date",
          value: Stdlib_Option.getOr(Stdlib_Option.map(props.end, LumiDate.dateWireFormat), ""),
          onChange: e => dispatch({
            TAG: "SetEnd",
            _0: Primitive_option.fromNullable(e.target.valueAsDate)
          })
        })
      }),
      JsxRuntime.jsx(Statistics$Controls$Field, {
        label: "Resolution",
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("select", {
            children: StatisticsTypes$Dashboard.intervals.map(interval => JsxRuntime.jsx("option", {
              children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                entry: {
                  TAG: "Interval",
                  _0: interval
                }
              }),
              value: interval
            }, interval)),
            value: props.interval,
            onChange: e => dispatch({
              TAG: "SetInterval",
              _0: e.target.value
            })
          }),
          className: "select is-fullwidth"
        })
      }),
      JsxRuntime.jsx(Statistics$Controls$Field, {
        label: "Data",
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("select", {
            children: StatisticsTypes$Dashboard.metrics.map(metric => JsxRuntime.jsx("option", {
              children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                entry: {
                  TAG: "Metric",
                  _0: metric
                }
              }),
              value: metric
            }, metric)),
            value: props.metric,
            onChange: e => dispatch({
              TAG: "SetMetric",
              _0: e.target.value
            })
          }),
          className: "select is-fullwidth"
        })
      }),
      props.kiosk ? null : JsxRuntime.jsx(Statistics$Controls$Field, {
          label: "Download",
          children: singleGroup !== undefined ? JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                        name: "file-csv"
                      }),
                      className: "icon"
                    }),
                    JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                        entry: "CSV"
                      })
                    })
                  ],
                  className: "button is-primary",
                  type: "button",
                  onClick: param => dispatch({
                    TAG: "Download",
                    _0: singleGroup,
                    _1: "CSV"
                  })
                }),
                JsxRuntime.jsxs("button", {
                  children: [
                    JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                        name: "file-excel"
                      }),
                      className: "icon"
                    }),
                    JsxRuntime.jsx("span", {
                      children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
                        entry: "Excel"
                      })
                    })
                  ],
                  className: "button is-primary",
                  type: "button",
                  onClick: param => dispatch({
                    TAG: "Download",
                    _0: singleGroup,
                    _1: "XLSX"
                  })
                })
              ],
              className: "buttons"
            }) : JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
              entry: "SelectOneFacilityToDownloadStatistics"
            })
        })
    ],
    className: "panel"
  });
}

let Controls = {
  Field: Field,
  make: Statistics$Controls
};

function Statistics$Aggregates(props) {
  let groups = Stdlib_Array.filterMap(Belt_Map.toArray(getSelectedGroups(props.selectedGroups, props.groupsSettings)), param => {
    let namedGroup = param[0];
    return Stdlib_Option.map(param[1].aggregate, agg => [
      namedGroup,
      agg
    ]);
  });
  let match = React.useState(() => Stdlib_Option.map(groups[0], param => param[0].groupFullId));
  let setSelectedTab = match[1];
  let selectedTab = match[0];
  let displayed = groups.find(param => Primitive_object.equal(selectedTab, param[0].groupFullId));
  let displayed$1 = displayed !== undefined ? displayed : groups[0];
  return LumiReact.renderOption(undefined, displayed$1, param => {
    let agg = param[1];
    let namedGroup = param[0];
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: "Aggregates"
          }),
          className: "panel-heading"
        }),
        JsxRuntime.jsx("p", {
          children: groups.map(param => {
            let match = param[0];
            let groupFullId = match.groupFullId;
            return JsxRuntime.jsx("a", {
              children: match.name,
              className: LumiReact.classList([[
                  "is-active",
                  Primitive_object.equal(namedGroup.groupFullId, groupFullId)
                ]]),
              onClick: param => setSelectedTab(param => groupFullId)
            }, SensorGroups$LumiStaticData.GroupFullId.toString(groupFullId));
          }),
          className: "panel-tabs"
        }),
        JsxRuntime.jsxs("p", {
          children: [
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "traffic-light"
              }),
              className: "panel-icon has-text-free"
            }),
            JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
              entry: "FreePlaces"
            })
          ],
          className: "panel-block"
        }),
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: {
              TAG: "MinMaxMean",
              _0: agg.freeMin,
              _1: agg.freeMax,
              _2: agg.freeMean
            }
          }),
          className: "panel-block"
        }),
        JsxRuntime.jsxs("p", {
          children: [
            JsxRuntime.jsx("span", {
              children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
                name: "traffic-light"
              }),
              className: "panel-icon has-text-occupied"
            }),
            JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
              entry: "OccupiedPlaces"
            })
          ],
          className: "panel-block"
        }),
        JsxRuntime.jsx("p", {
          children: JsxRuntime.jsx(Translation$Dashboard.Provider.Text.make, {
            entry: {
              TAG: "MinMaxMean",
              _0: agg.occupiedMin,
              _1: agg.occupiedMax,
              _2: agg.occupiedMean
            }
          }),
          className: "panel-block"
        })
      ],
      className: "panel"
    });
  });
}

let Aggregates = {
  make: Statistics$Aggregates
};

function Statistics(props) {
  let facilityInfos = props.facilityInfos;
  let toAuth = Barrier$LumiAuthentication.Dispatch.useContext();
  let loadGroupStatistics = (param, group, dispatch) => {
    let end = param.end;
    let begin = param.begin;
    if (begin !== undefined && end !== undefined) {
      return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.getSensorGroupStateHistoryAggregates(group.groupFullId, begin, end, param.interval), data => dispatch({
        TAG: "GroupStatisticsReceived",
        _0: group,
        _1: data
      }), err => {
        console.error("getGroupStatistics failed", err);
        Barrier$LumiAuthentication.checkServerError(err, toAuth);
      });
    }
  };
  let reloadAll = param => {
    let dispatch = param.dispatch;
    let state = param.state;
    return LumiReact.effects(Belt_Map.keysToArray(getSelectedGroups(state.selectedGroups, state.groupsSettings)).map(group => loadGroupStatistics(state, group, dispatch)));
  };
  let match = LumiReactReducer.useReducer(() => {
    let end = new Date();
    let begin = new Date(end.getTime());
    begin.setMonth(end.getMonth() - 1 | 0);
    return {
      TAG: "Init",
      _0: {
        selectedGroups: Belt_Set.make(SensorGroups$LumiStaticData.GroupFullId.Cmp),
        begin: begin,
        end: end,
        interval: "hour",
        metric: "occupiedMax",
        groupsSettings: Belt_Map.fromArray(facilityInfos.map(param => param.groups).flat().map(group => [
          group,
          {
            statistics: undefined,
            aggregate: undefined,
            color: undefined
          }
        ]), Statistics$LumiCentral.NamedGroupCmp)
      }
    };
  }, undefined, (state, action) => {
    switch (action.TAG) {
      case "SelectGroup" :
        let group = action._0;
        return {
          TAG: "UpdateWithEffect",
          _0: {
            selectedGroups: Belt_Set.add(state.selectedGroups, group.groupFullId),
            begin: state.begin,
            end: state.end,
            interval: state.interval,
            metric: state.metric,
            groupsSettings: updateGroup(state.groupsSettings, group, settings => ({
              statistics: settings.statistics,
              aggregate: settings.aggregate,
              color: LumiOption.orElse(settings.color, () => getNextColor(state))
            }))
          },
          _1: param => {
            let state = param.state;
            if (Stdlib_Option.isNone(Stdlib_Option.flatMap(Belt_Map.get(state.groupsSettings, group), settings => settings.statistics))) {
              return loadGroupStatistics(state, group, param.dispatch);
            }
          }
        };
      case "DeselectGroup" :
        return {
          TAG: "Update",
          _0: {
            selectedGroups: Belt_Set.remove(state.selectedGroups, action._0.groupFullId),
            begin: state.begin,
            end: state.end,
            interval: state.interval,
            metric: state.metric,
            groupsSettings: state.groupsSettings
          }
        };
      case "GroupStatisticsReceived" :
        let data = action._1;
        return {
          TAG: "Update",
          _0: {
            selectedGroups: state.selectedGroups,
            begin: state.begin,
            end: state.end,
            interval: state.interval,
            metric: state.metric,
            groupsSettings: updateGroup(state.groupsSettings, action._0, settings => ({
              statistics: data,
              aggregate: Statistics$LumiCentral.aggregate(data.map(prim => prim[1])),
              color: settings.color
            }))
          }
        };
      case "SetBegin" :
        return {
          TAG: "UpdateWithEffect",
          _0: {
            selectedGroups: state.selectedGroups,
            begin: action._0,
            end: state.end,
            interval: state.interval,
            metric: state.metric,
            groupsSettings: state.groupsSettings
          },
          _1: reloadAll
        };
      case "SetEnd" :
        return {
          TAG: "UpdateWithEffect",
          _0: {
            selectedGroups: state.selectedGroups,
            begin: state.begin,
            end: action._0,
            interval: state.interval,
            metric: state.metric,
            groupsSettings: state.groupsSettings
          },
          _1: reloadAll
        };
      case "SetInterval" :
        return {
          TAG: "UpdateWithEffect",
          _0: {
            selectedGroups: state.selectedGroups,
            begin: state.begin,
            end: state.end,
            interval: action._0,
            metric: state.metric,
            groupsSettings: state.groupsSettings
          },
          _1: reloadAll
        };
      case "SetMetric" :
        return {
          TAG: "Update",
          _0: {
            selectedGroups: state.selectedGroups,
            begin: state.begin,
            end: state.end,
            interval: state.interval,
            metric: action._0,
            groupsSettings: state.groupsSettings
          }
        };
      case "Download" :
        let contentType = action._1;
        let group$1 = action._0;
        return {
          TAG: "Effect",
          _0: param => {
            let match = param.state;
            let end = match.end;
            let begin = match.begin;
            if (begin !== undefined && end !== undefined) {
              return LumiRequest.resultFutureEffect(Stallingsnet$LumiCentral.downloadSensorGroupStateHistoryAggregates(group$1.groupFullId, begin, end, match.interval, contentType), data => {
                let match = contentType === "JSON" ? [
                    "export.json",
                    "application/json;charset=utf-8"
                  ] : (
                    contentType === "XLSX" ? [
                        "export.xlsx",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      ] : [
                        "export.csv",
                        "text/csv;charset=utf-8"
                      ]
                  );
                let blob = new Blob([data], {
                  type: match[1]
                });
                FileSaver.saveAs(blob, match[0]);
              }, err => {
                console.error("downloadSensorGroupStateHistoryAggregates failed", err);
                Barrier$LumiAuthentication.checkServerError(err, toAuth);
              });
            }
          }
        };
    }
  });
  let dispatch = match[1];
  let match$1 = match[0];
  let groupsSettings = match$1.groupsSettings;
  let metric = match$1.metric;
  let interval = match$1.interval;
  let selectedGroups = match$1.selectedGroups;
  let selected = Belt_Map.keysToArray(getSelectedGroups(selectedGroups, groupsSettings));
  let singleGroup = selected.length !== 1 ? undefined : selected[0];
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Statistics$GroupList, {
          facilityInfos: facilityInfos,
          groupsSettings: groupsSettings,
          selectedGroups: selectedGroups,
          dispatch: dispatch
        }),
        className: "column is-narrow sidebar"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Statistics$Chart, {
          selectedGroups: selectedGroups,
          groupsSettings: groupsSettings,
          interval: interval,
          metric: metric
        }),
        className: "column is-flex fill-available"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Statistics$Controls, {
            kiosk: props.kiosk,
            singleGroup: singleGroup,
            begin: match$1.begin,
            end: match$1.end,
            interval: interval,
            metric: metric,
            dispatch: dispatch
          }),
          JsxRuntime.jsx(Statistics$Aggregates, {
            selectedGroups: selectedGroups,
            groupsSettings: groupsSettings
          })
        ],
        className: "column is-2 is-flex-direction-column scrollable"
      })
    ]
  });
}

let make = Statistics;

export {
  getSelectedGroups,
  updateGroup,
  colors,
  getNextColor,
  GroupList,
  Chart,
  Controls,
  Aggregates,
  make,
}
/* react Not a pure module */
